<template>
  <ob-modal2 :show.sync="show" :width="900" :backdrop="false">
    <template slot="modal-title">
        Update Personal Details
    </template>
    <template slot="modal-body">
    <div  class="update-info">
                    <div class="row m0">
                        <div class="col-md-12 section-personal">
                            <div class="row m0">
                                <div class="col-md-3 pL0">
                                    <div class="form-group">
                                        <label>First Name</label>
                                        <ob-input disabled v-model.trim="empInfo.FirstName"
                                                  placeholder="First Name"></ob-input>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Middle Name</label>
                                        <ob-input disabled v-model.trim="empInfo.MiddleName" placeholder="Middle Name" ></ob-input>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Last Name</label>
                                        <ob-input disabled v-model.trim="empInfo.LastName"
                                                  placeholder="Last Name"></ob-input>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Designation</label>
                                        <ob-input disabled v-model.trim="empInfo.Designation" placeholder="Designation"></ob-input>
                                    </div>
                                </div>
                            </div>
                            <div class="row m0">
                                <div class="col-md-3 pL0">
                                    <div class="form-group">
                                        <label>Email ID</label>
                                        <ob-input v-model.trim="empInfo.EmailId" disabled placeholder="Email ID"></ob-input>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Phone Number<span class="rcss-text-red"></span></label>
                                         <ob-input v-phone-number v-model.trim="empInfo.PhoneNo" placeholder="Phone Number"  @input="$v.empInfo.PhoneNo.$touch()"></ob-input>
                                                <!-- <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.PhoneNo.$dirty && !$v.empInfo.PhoneNo.required">Please enter phone number</span>
                                                <span class="ob-vuelidate_error-msg" v-if="empInfo.PhoneNo && empInfo.SecondaryPhoneNo.includes(empInfo.PhoneNo)">Primary phone number can't be same as secondary phone number</span> -->
                                                <!-- <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.PhoneNo.$dirty && !$v.empInfo.PhoneNo.phoneNumber && $v.empInfo.PhoneNo.required">Please enter valid phone number</span> -->
                                                <!-- <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.PhoneNo.$dirty && !$v.empInfo.PhoneNo.maxLength && $v.empInfo.PhoneNo.phoneNumber">Please enter valid phone number</span> -->
                                                <!-- <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.PhoneNo.$dirty && !$v.empInfo.PhoneNo.minLength && $v.empInfo.PhoneNo.phoneNumber">Please enter valid phone number</span> -->
                                    </div>
                                </div>
                                <div class="col-md-6 pR0">
                                    <div class="form-group gender-options">
                                        <label>Gender</label>
                                        <div class="radio-inline">
                                            <ob-radio  v-model="empInfo.Gender" val="Male">Male</ob-radio>
                                        </div>
                                        <div class="radio-inline">
                                            <ob-radio  v-model="empInfo.Gender" val="Female">Female</ob-radio>
                                        </div>
                                        <div class="radio-inline">
                                            <ob-radio  v-model="empInfo.Gender" val="Not Disclosed">I choose not to disclose</ob-radio>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m0">
                                <div class="col-md-3 pL0">
                                    <div class="form-group">
                                        <label>Date of Birth</label>
                                        <ob-date-time-picker id="dob" placeholder="Date of Birth" :options="options1" :inputvalue="this.$parent.formatDOB" @updated="(v) => this.empInfo.DOBString = v" v-model.trim="empInfo.DOBString"></ob-date-time-picker>
                                    </div>
                                </div>

                            </div>
                            <div class="row m0"  v-if="loggedInUserObj.HireType == 'W2'" >
                                <div class="col-md-4 pL0">
                                    <div class="form-group">
                                        <label>Ethnicity</label>
                                        <ob-select2 :inModal ="true" v-if="ethinicityList.data.length > 0" v-model.trim="empInfo.Ethinicity" :options="ethinicityList"></ob-select2>
                                    </div>
                                </div>
                                <div class="col-md-4 ">
                                    <div class="form-group">
                                        <label>Veteran Status</label>
                                        <ob-select2 :inModal ="true" v-if="veteranList.data.length > 0" :options="veteranList" v-model.trim="empInfo.VeteranStatus"></ob-select2>
                                    </div>
                                </div>
                            </div>



                            <!--col-md-12-->
                        </div>

                        <!--row-->

                    </div>
                    <div class="row m0">
                        <div class="col-md-12 section-personal">
                            <h4>Current Home Address</h4>
                            <div class="row m0">
                                <div class="col-md-3 pL0">
                                    <div class="form-group">
                                        <label>Address Line 1</label>
                                        <ob-input v-model.trim="empInfo.Address.Address1" placeholder="Address Line 1"></ob-input>
                                    </div>
                                </div>
                                <div class="col-md-3 ">
                                    <div class="form-group">
                                        <label>Address Line 2</label>
                                        <ob-input v-model.trim="empInfo.Address.Address2" placeholder="Address Line 2"></ob-input>
                                    </div>
                                </div>
                                <div class="col-md-3 ">
                                    <div class="form-group">
                                        <label>City, State <i class="fa fa-info-circle" v-tooltip="'Please enter atleast first two letters of your City and select options listed.'"></i></label>
                                        <location-search :key="updateLocationkey" :inModal ="true" :vmodelData.sync="empInfo.Address.AddressSummary" @input="getZipCode(empInfo)"></location-search>
                                    </div>
                                </div>
                                <div class="col-md-3 ">
                                    <div class="form-group">
                                        <label>Zip code</label>
                                        <ob-input placeholder="Zip code" v-model.trim="empInfo.Address.ZipCode" :maxLength="5" v-number-only></ob-input>
                                    </div>
                                </div>
                            </div>
                             <div class="row">
                                <div class="col-md-6 form-group ">
                                <div class="col-md-6 pL0" style="padding-right:5px;">
                                    <label>Period of Stay (From)</label>
                                    <ob-date-time-picker ref="PeriodOfStayFrom" v-model ="empInfo.Address.PeriodOfStayFrom" class="offer-input" id="PeriodOfStayFrom" placeholder="From date" :inputvalue="empInfo.Address.PeriodOfStayFrom" :options="datePickerOptions" @updated="(v) => empInfo.Address.PeriodOfStayFrom = v" :dpchange="onCreatedFrom"></ob-date-time-picker>
                                    <!-- <span class="ob-vuelidate_error-msg" style="font-weight: 300;"  v-if="$v.empInfo.Address.PeriodOfStayFrom.$dirty && !$v.empInfo.Address.PeriodOfStayFrom.requiredIf"> Select From date for Period of stay</span> -->
                                </div>
                                <div class="col-md-6 ">
                                    <label>Period of Stay (To)</label>
                                    <ob-date-time-picker ref="PeriodOfStayTo" class="offer-input" v-model ="empInfo.Address.PeriodOfStayTo" id="PeriodOfStayTo" placeholder="To date" :inputvalue="empInfo.Address.PeriodOfStayTo" :options="datePickerOptions" @updated="(v) => empInfo.Address.PeriodOfStayTo = v"></ob-date-time-picker>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row m0">
                        <div class="col-md-12 section-personal">
                            <h4 v-if="loggedInUserObj.HireType == 'W2'">Employment Details</h4>
                            <h4 v-else>Contract Details</h4>
                            <div class="row m0">
                                <div class="col-md-4 pL0">
                                  <div class="form-group">
                                      <label>Employment Type</label>
                                      <ob-select2 :disabled="isDisabled" :options="EmploymentWorkTypeOptions" v-model="empInfo.EmploymentWorkType"></ob-select2>
                                       <span v-if="empInfo.EmployeeEffectiveFromString != null && empInfo.EmployeeEffectiveFromString != ''">
                                          <span class="personalfile_data"><a>Effective From : {{empInfo.EmployeeEffectiveFromString}}</a></span>
                                        </span>
                                  </div>
                                </div>
                                <div class="col-md-4" v-if="loggedInUserObj.HireType == 'W2'">
                                    <div class="form-group">
                                        <label>Employment/Contract Start Date</label>
                                        <ob-date-time-picker id="esd" :inputvalue="this.$parent.formatEmpStartDate"
                                                             :disabled="isDisabled" :options="options" @updated="this.$parent.changeEmpPeriod" v-model.trim="empInfo.EmployementStartDate"></ob-date-time-picker>
                                    </div>
                                </div>
                                 <div class="col-md-4" v-else>
                                    <div class="form-group">
                                        <label>Employment/Contract Start Date</label>
                                        <ob-date-time-picker id="esd" :inputvalue="this.$parent.formatProjectStartDate"
                                                             :disabled="isDisabled" :options="options" @updated="this.$parent.changeContractPeriod" v-model.trim="empInfo.CurrentProjectStartDate"></ob-date-time-picker>
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="loggedInUserObj.HireType == 'W2'">
                                    <div class="form-group">
                                        <label>Employment Period</label>
                                        <ob-input disabled v-model="empInfo.YearsOfEmployement" placeholder="Employment Period"></ob-input>
                                    </div>
                                </div>
                                <div class="col-md-4" v-else>
                                    <div class="form-group">
                                        <label>Period of Employement/Contract</label>
                                        <ob-input disabled v-model="empInfo.YearsOfEmployement" placeholder="Employment Period"></ob-input>
                                    </div>
                                </div>

                            </div>
                            <div class="row m0">
                                <div class="col-md-4 pL0" >
                                    <div class="form-group">
                                        <label>Employee ID</label>
                                        <ob-input disabled v-model.trim="empInfo.EmployeeId" placeholder="Employee Id"></ob-input>
                                    </div>
                                </div>
                                <div class="col-md-4 pL0" v-if="loggedInUserObj.HireType != 'W2'">
                                    <div class="form-group">
                                        <label>Work Authorization Type</label>
                                        <ob-input disabled v-model.trim="empInfo.WorkAuthorizationType" placeholder="N/A"></ob-input>
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="loggedInUserObj.HireType == 'W2'">
                                    <div class="form-group">
                                        <label>Wage Rate (Offered salary)</label>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <ob-input icon="fa-usd" disabled :maxLength="10" v-decimal-numbers  v-model="empInfo.MinWageRate" placeholder="From"></ob-input>
                                                </div>
                                                <div class="col-md-6">
                                                    <ob-input icon="fa-usd" disabled :maxLength="10" v-decimal-numbers :class="{ 'ob-vuelidate_input-error': $v.empInfo.MaxWageRate.$error }" v-model="empInfo.MaxWageRate" placeholder="To"></ob-input>
                                                </div>
                                            </div>
                                            <span v-if="empInfo.WageEffectiveFromString != null && empInfo.WageEffectiveFromString != ''">
                                              <span class="personalfile_data"><a>Effective From : {{empInfo.WageEffectiveFromString}}</a></span>
                                            </span>
                                    </div>
                                </div>
                                <div class="col-md-6"  v-else>
                                    <div class="form-group">
                                        <label>Wage Rate (Offered salary)</label>
                                          <div class="row">
                                              <div class="col-md-6">
                                                  <ob-input icon="fa-usd" disabled :maxLength="10" v-decimal-numbers  v-model="empInfo.MinWageRate" placeholder="From"></ob-input>
                                              </div>
                                          </div>
                                          <span v-if="empInfo.WageEffectiveFromString != null && empInfo.WageEffectiveFromString != ''">
                                              <span class="personalfile_data"><a>Effective From : {{empInfo.WageEffectiveFromString}}</a></span>
                                          </span>
                                    </div>
                                </div>
                                <div class="col-md-4 pL0">
                                    <div class="form-group">
                                        <label>Department</label>
                                        <ob-input disabled v-model.trim="departmentName" placeholder="N/A"></ob-input>
                                    </div>
                                </div>
                            </div>
                            <div class="row m0">
                                <div class="col-md-4 pL0" v-if="loggedInUserObj.HireType == 'W2'">
                                  <label>Benefits Status</label>
                                  <ul class="list-unstyled list-inline">
                                      <li>
                                          <div class="radio-inline pL0"><ob-radio :disabled="isDisabled" name="options" val="Applicable" v-model="empInfo.BenefitsStatus" @input="changeBenefitsStatus(empInfo.BenefitsStatus)">Applicable</ob-radio></div>
                                      </li>
                                      <li>
                                          <div class="radio-inline" style="padding-left: 10px;"><ob-radio :disabled="isDisabled" name="options" val="NotApplicable" v-model="empInfo.BenefitsStatus" @input="changeBenefitsStatus(empInfo.BenefitsStatus)">Not Applicable</ob-radio></div>
                                      </li>
                                  </ul>
                                  <span v-if="empInfo.BenefitsEffectiveFromString != null && empInfo.BenefitsEffectiveFromString != ''">
                                      <span class="personalfile_data"><a>Effective From : {{empInfo.BenefitsEffectiveFromString}}</a></span>
                                  </span>
                                </div>
                                <div class="col-md-4 pL0" v-if="(this.$parent.WorkPermit != 'OPT EAD' || this.$parent.WorkPermit != 'CPT') && empInfo.BenefitsStatus == 'Applicable' && loggedInUserObj.HireType == 'W2'">
                                  <div class="form-group">
                                      <label>Benefits Type</label>
                                      <ob-select2 disabled v-if="benifitsList.data.length > 0" :options="benifitsList" :multiple="true" v-model.trim="empInfo.BenifitsValue"></ob-select2>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h4 class="remove-header section-personal border-0 mB0" style="padding: 10px 0" v-if="empInfo.Depandants.length < 2 && loggedInUserObj.HireType == 'W2'" >Dependent Details </h4>
                    <div class="row m0" v-for="(d,index) in empInfo.Depandants"  v-if="loggedInUserObj.HireType == 'W2'" :key="index">
                        <div class="col-md-12 section-personal border-0 p0">

                            <h4 class="remove-header mB0" style="padding: 10px 0" v-if="empInfo.Depandants.length > 1">Dependent Details {{index+1}}</h4>
                            <a href="javascript:;" class="remove-color" type="link" @click="removeDependent(index)" :class="{'remove-emptycount':empInfo.Depandants.length < 2}">Remove Dependent</a>
                            <div class="row m0">
                                <div class="col-md-3 pL0">
                                    <div class="form-group">
                                        <label>Dependent Type</label>
                                        <ob-select2 :inModal ="true" v-if="dependantTypeList.data.length > 0" :options="dependantTypeList" v-model.trim="d.DependantType"></ob-select2>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].DependantType.$dirty && !$v.empInfo.Depandants.$each[index].DependantType.requiredIf">Please select benefits</span>
                                    </div>

                                </div>
                                <div class="col-md-3 ">
                                    <div class="form-group">
                                        <label>First Name</label>
                                        <ob-input placeholder="First Name" v-formi9-name v-model.trim="d.FirstName" :class="{ 'ob-vuelidate_input-error': $v.empInfo.Depandants.$each[index].FirstName.$error }" @input="updateValue('firstName', d.FirstName, index)"></ob-input>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].FirstName.$dirty && !$v.empInfo.Depandants.$each[index].FirstName.requiredIf">Please enter First name</span>
                                        <!-- <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].FirstName.$dirty && !$v.empInfo.Depandants.$each[index].FirstName.alphawithspace">Please enter alphabets only</span> -->
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].FirstName.$dirty && !$v.empInfo.Depandants.$each[index].FirstName.maxLength && $v.empInfo.Depandants.$each[index].FirstName.alpha">Please enter 150 characters only</span>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].FirstName.$dirty &&  !$v.empInfo.Depandants.$each[index].FirstName.alpha && !$v.empInfo.Depandants.$each[index].FirstName.letterCount">Each word can have a maximum of 100 characters only.</span>

                                    </div>

                                </div>
                                <div class="col-md-3 ">
                                    <div class="form-group">
                                        <label>Last Name</label>
                                        <ob-input placeholder="Last Name" v-formi9-name v-model.trim="d.LastName" :class="{ 'ob-vuelidate_input-error': $v.empInfo.Depandants.$each[index].LastName.$error }" @input="updateValue('lastName', d.LastName, index)"></ob-input>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].LastName.$dirty && !$v.empInfo.Depandants.$each[index].LastName.requiredIf">Please enter Last name</span>
                                        <!-- <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].LastName.$dirty && !$v.empInfo.Depandants.$each[index].LastName.alphawithspace">Please enter alphabets only</span> -->
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].LastName.$dirty && !$v.empInfo.Depandants.$each[index].LastName.maxLength && $v.empInfo.Depandants.$each[index].LastName.alpha">Please enter 150 characters only</span>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].LastName.$dirty &&  !$v.empInfo.Depandants.$each[index].LastName.alpha && !$v.empInfo.Depandants.$each[index].LastName.letterCount">Each word can have a maximum of 100 characters only.</span>
                                    </div>

                                </div>
                                <div class="col-md-3 ">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <ob-input placeholder="Email" v-model.trim="d.Email" :class="{ 'ob-vuelidate_input-error': $v.empInfo.Depandants.$each[index].Email.$error }"></ob-input>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].Email.$dirty && !$v.empInfo.Depandants.$each[index].Email.email">Please enter valid email</span>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].Email.$dirty && !$v.empInfo.Depandants.$each[index].Email.maxLength && $v.empInfo.Depandants.$each[index].Email.alpha">Please enter 150 characters only</span>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].Email.$dirty &&  !$v.empInfo.Depandants.$each[index].Email.alpha && !$v.empInfo.Depandants.$each[index].Email.letterCount">Each word can have a maximum of 100 characters only.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row m0">
                                <div class="col-md-3 pL0">
                                    <div class="form-group">
                                        <label>Phone Number</label>
                                        <ob-input placeholder="Phone" v-number-only v-model.trim="d.MobileNo"></ob-input>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Visa Status</label>
                                        <ob-select2 :inModal ="true" v-if="visaList.data.length > 0" :options="visaList" :class="{ 'ob-vuelidate_input-error': $v.empInfo.Depandants.$each[index].VisaStatus.$error }" v-model.trim="d.VisaStatus"></ob-select2>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].VisaStatus.$dirty && !$v.empInfo.Depandants.$each[index].VisaStatus.requiredIf">Please select visa status</span>

                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Benefits</label>
                                        <ob-select2 :inModal ="true" v-if="benifitsList.data.length > 0" :options="benifitsList" :multiple="true" v-model.trim="d.Benifits"></ob-select2>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                    <div class="add-work-new" v-if="loggedInUserObj.HireType == 'W2'"> <a href="javascript:;" class="mL0" @click="addDependent()">Add Another Dependent</a> </div>
                </div>
    </template>
    <template slot="modal-footer">
      <ob-button type="secondary" @click="cancel">Cancel</ob-button>
      <ob-button type="primary" @click ="updateInfo" :disabled="isSending ||((empInfo.SecondaryPhoneNo) ? empInfo.SecondaryPhoneNo.includes(empInfo.PhoneNo):false)" ref="updatebtn">Update</ob-button>
    </template>
  </ob-modal2>
</template>
<script>
    import namevalidation from "Vue/Core/namevalidation.js"
    import { required, minLength, maxLength, requiredIf, email, alpha, minValue } from 'vuelidate/lib/validators'
    import { req, withParams } from 'vuelidate/lib/validators/common'
    const DecimalNumber = withParams({ type: 'DecimalNumber' }, value => {
        return !req(value) || /^\d+(\.\d{1,2})?$/.test(value);
    })
    const alphawithspace = (value) => {
        var alsp = /^[a-zA-Z\s]*$/i
        return alsp.test(value)
    }
    const phoneNumber = (value) => {
        var phone = /^[0-9 +()-]+$/i
        return phone.test(value)
    }
    const letterCount = withParams({ type: 'letterCount' }, value => {
        if (value != null && value.length <= 150) {
            var strArr = value.split(" ");
            let error = true;
            strArr.forEach(function (word) {
                if (word.length > 100) {
                    error = false
                    return;
                }
            });
            return !req(value) || error
        }
        else {
            return true
        }

    })
export default {
     props: ["openModal","empData"],
     data() {
            return {
                 isDisabled: true,
                 show: false,
                 isSending: false,
                 departmentName:'',
                 empInfo: {
                    DOBString:'',
                    Address: {
                        AddressSummary:'',
                        Address1:'',
                        Address2:'',
                        PeriodOfStayFrom:''
                    },
                    Benifits: '',
                    BenifitsList: '',
                    BenifitsValue: '',
                    BillRate: '',
                    Company: "",
                    DOB: "",
                    Designation: '',
                    EmailId: '',
                    EmployementStartDate: '',
                    EmployementStartDateString: '',
                    CurrentProjectStartDateString:'',
                    CurrentProjectStartDate:'',
                    Ethinicity: '',
                    EthinicityList: '',
                    FirstName: '',
                    Gender: '',
                    LastName: '',
                    Location: '',
                    MaxWageRate: '',
                    MiddleName: '',
                    MinWageRate: '',
                    PhoneNo: "",
                    RecruiterEmail: "",
                    RecruiterName: "",
                    Salary: '',
                    VeteranList: '',
                    VeteranStatus: '',
                    VisaList: '',
                    YearsOfEmployement: "",
                    Depandants: [],
                    HireType:'',
                    WorkPermit:'',
                    WorkAuthorizationType:'',
                    EmploymentWorkType:'',
                    BenefitsEffectiveFrom:'',
                    WageEffectiveFrom:'',
                    BenefitsEffectiveFromString:'',
                    WageEffectiveFromString:'',
                    BenefitsStatus:'',
                    EmployeeEffectiveForm:'',
                    EmployeeEffectiveFromString:''
                },
                leavesAVac: null,
                options1: {
                    format: 'MM/DD/YYYY',
                    dayViewHeaderFormat: 'MM/DD/YYYY',
                    maxDate: moment().subtract(15, 'years'),
                    ignoreReadonly: true,
                    widgetPositioning: {
                        horizontal: "auto",
                        vertical: "bottom"
                    }
                },
                datePickerOptions: {
                format: 'MM/DD/YYYY'
                },
                options: {
                    format: 'MM/DD/YYYY',
                    ignoreReadonly: true,
                    widgetPositioning: {
                        horizontal: "auto",
                        vertical: "bottom"
                    }
                },
                deptList: {
                    placeholder: {
                        id: '-1', // the value of the option
                        text: 'Please select'
                    },
                    data: []
                },
                veteranList: {
                    placeholder: {
                        id: '-1', // the value of the option
                        text: 'Please select'
                    },
                    data: []
                },
                ethinicityList: {
                    placeholder: {
                        id: '-1', // the value of the option
                        text: 'Please select'
                    },
                    data: []
                },
                visaList: {
                    placeholder: {
                        id: '-1', // the value of the option
                        text: 'Please select'
                    },
                    data: []
                },
                dependantTypeList: {
                    placeholder: {
                        id: '-1', // the value of the option
                        text: 'Please select'
                    },
                    data: []
                },
                benifitsList: {
                    placeholder: {
                        id: '-1', // the value of the option
                        text: 'Please select'
                    },
                    data: []
                },
                updateLocationkey:0,
                EmploymentWorkTypeOptions:{
                  placeholder: {
                      id: '-1',
                      text: 'Select'
                  },
                  data: [
                      { id: 'FullTime', text: 'Full-Time' },
                      { id: 'PartTime', text: 'Part-Time' },
                      { id: 'Temporary', text: 'Temporary' },
                      { id: 'Intern', text: 'Intern' }
                  ],
                  minimumResultsForSearch: -1
                }
            }
        },
        computed: {
                updateAddressSummary(){
                   return this.empInfo.Address.AddressSummary
                }
            },
        watch:{
            updateAddressSummary(val){
                    if(val == null){
                        this.empInfo.Address.AddressSummary = this.empInfo.Address.City+', '+this.empInfo.Address.State
                        this.updateLocationkey++
                    }
                   else if(val == ','){
                        this.empInfo.Address.AddressSummary = ''
                    }
                } ,
            openModal(val){
              if(val == true){
                 this.empInfo = this.empData
                 this.empInfo.Gender = this.empData.Gender == "Not Specified" || this.empData.Gender == "NotSpecified" ? "Not Disclosed" : this.empData.Gender
                 this.dependantTypeList.data = this.empData.DependantTypeList
                 this.benifitsList.data = this.empData.BenifitsList
                 this.benifitsList.data.forEach((r,i) => {
                        if(r == "401K") {
                              this.benifitsList.data[i] = "K401"
                        }
                    })
                 this.visaList.data = this.empData.VisaList
                 this.ethinicityList.data = this.empData.EthinicityList
                 this.veteranList.data = this.empData.VeteranList
                 if(this.empInfo && this.empInfo.Department && this.empInfo.Department.Name){
                    this.departmentName = this.empInfo.Department.Name
                 }
                 this.show = true;
            }
            },
            show(val) {
              this.$emit('update:openModal', val)
            },
        },

        created(){
            this.show = this.openModal
          },
        methods:{
          updateValue(modelName, value, index){
            let val = namevalidation.getValidName(value);
            if(modelName == "firstName")
                this.empInfo.Depandants[index].FirstName = val
            else
                this.empInfo.Depandants[index].LastName = val
          },
            onCreatedFrom(e) {
            this.$refs.PeriodOfStayTo.data.minDate(e.date)
            },
            addDependent(){
                this.$parent.addDependent()
            },
           removeDependent(indexVal){
            this.$v.empInfo.$reset()
            this.$parent.empInfo.Depandants.splice(indexVal,1)

           },
           updateInfo(){
               this.$v.empInfo.$touch();
                if(this.$v.empInfo.$invalid == false)
                {
                    this.$parent.updateInfo()
                    this.show = false
                }
            },
            getZipCode(l) {
                setTimeout(() => {
                    if (l.Address.AddressSummary != '') {
                        ajax.get(`/Account/GetZipCode?location=${l.Address.AddressSummary}`, {}, (res) => {
                            if (res.data.State == true) {
                                l.Address.ZipCode = res.data.ZipCodeModel.ZipCode
                            }
                            else{
                                this.ESSEnableDisable(res)
                            }
                        })
                    }
                    else
                        l.Zip = ''

                }, 100)
            },
            cancel(){
             this.empInfo = null
            this.$parent.getEmployeeDatails()
            this.empInfo = this.empData
            this.$v.empInfo.$reset()
            this.show = false
           },
        },

        validations() {
            return {

                empInfo: {
                    "MinWageRate": {
                        DecimalNumber
                    },
                    "MaxWageRate": {
                        DecimalNumber
                    },
                    // "PhoneNo":{
                    //             required,
                    //             phoneNumber,
                    //             maxLength: maxLength(20),
                    //             minLength: minLength(10),
                    //         },
                    "Depandants": {
                        $each: {
                            "DependantType": {
                                requiredIf: requiredIf((d) => {
                                    return d.DependantType != '' && d.DependantType != 'None'
                                })
                            },
                            "FirstName": {
                                requiredIf: requiredIf((d) => {
                                    return d.DependantType != '' && d.DependantType != 'None'
                                }),
                                // alphawithspace,
                                maxLength: maxLength(150),
                                letterCount
                            },
                            "LastName": {
                                requiredIf: requiredIf((d) => {
                                    return d.DependantType != '' && d.DependantType != 'None'
                                }),
                                // alphawithspace,
                                maxLength: maxLength(150),
                                letterCount
                            },
                            "Email": {
                                email,
                                maxLength: maxLength(150),
                                letterCount
                            },
                            "VisaStatus": {
                                requiredIf: requiredIf((d) => {
                                    return d.DependantType != '' && d.DependantType != 'None'
                                })
                            }
                        }
                    },
                //     Address: {
                //     PeriodOfStayFrom: {

                //        requiredIf:requiredIf(() =>{
                //         if(this.empInfo.Address.Address1 != '' || this.empInfo.Address.Address2 != '' && this.empInfo.Address.PeriodOfStayFrom == ''){
                //             return true
                //           }
                //           else{
                //             return false
                //           }
                //        })
                //     }
                // }
                }
            }
        },
}
</script>
<style lang="scss" scoped>
    @import "~styles/framework/vue-utils";

    @import "~styles/framework/bootstrap/forms";

    .personal-main {
        h4

    {
        color: $ob-brand-primary;
        font-weight: 600;
    }

    .personal-header {
        display: inline-block;
        width: calc(100% - 30px);
        padding: 15px 0 0px 0;
		border-bottom: 1px dashed #ccc;
        margin: 0 15px;
        h4

    {
        /*display: inline-block;*/
        float: left;
    }

    .init-button {
        /*display: inline-block;*/
        float: right;
    }

    }

    .personal-body {
        padding: 0 15px;
        display: inline-block;
        width: 100%;
        min-height: 350px;
        .info-block

    {
        display: inline-block;
        width: 100%;
        border-bottom: 2px dashed #c2c2c2;
        padding-bottom: 10px;
        .info-single

    {
        width: calc(20% - 3px);
        display: inline-block;
        padding: 15px 0;
        vertical-align: top;
        label

    {
        font-size: 11px;
        width: 100%;
        margin: 0;
    }

    .spann {
        display: inline-block;
        color: $ob-brand-primary;
        font-size: 13px;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 140px;
        white-space: nowrap;
    }

    }
    }

    .update-info {
        position: relative;
        .info-single

    {
        width: calc(25% - 4px);
        padding: 15px;
    }

    }

    .inner-heading {
        display: inline-block;
        width: 100%;
        padding: 15px 0px;
        h4

    {
        margin: 0;
    }

    }
    }

    .add-dependent {
        position: relative;
        width: 100%;
        display: inline-block;
        .dependent-common

    {
        position: absolute;
        right: 0;
    }

    .add {
        top: -40px;
    }

    .remove {
        top: -45px;
    }

    }
    }

    .no-candidates {
        position: absolute;
        left: 35%;
        top: 100px;
        img

    {
        width: 200px;
    }

    }

    .view-job-popup {
        color: #4A90E2;
        display: inline-block;
        font-size: 12px;
        font-style: italic;
        font-weight: 600;
        padding-left: 10px;
        cursor: pointer;
    }

    .remove-color:hover,
    .remove-color {
        float: right;
        color: #F31D1D;
        font-size: 13px;
        font-weight: 600;
        margin-top: 15px;
    }

    .personalfile-details {
        padding: 10px 0;
    }

    .personalfile_data {
        font-weight: 600;
        color: #143361;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .section-personal {
        border-bottom: 2px dashed #c2c2c2;
        padding: 10px 0;
    }

    .deptype-data {
        font-weight: 600;
        color: #143361;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        display: block;
    }

    .remove-header {
        display: inline-block;
    }

    .add-work-new {
        padding-bottom: 15px;
        a

    {
        color: #5d91e2;
        font-size: 13px;
        font-weight: 600;
        margin-bottom: 15px;
        margin-top: 0;
        margin-left: 15px;
    }

    }

    .border-0 {
        border: 0 !important;
    }

    .empty-projectbtn {
        padding: 5px 15px;
        background: #ffe8c3;
    }

    .btn-projectright {
        float: right;
    }

    .btn-alert-projecttext {
        font-weight: 600;
        color: #333;
        display: inline-block;
        // transform: translatey(5px);
    }

    .benfitdata {
        display: block;
    }

    .personalfile-address {
        padding: 10px 15px;
    }

    .validation-star {
        color: #F31D1D;
    }

    .gender-options {
        margin: 26px 0 0 0;
    }

    .ob-workForce__Status {
        padding: 3px 10px;
        color: #fff;
        font-weight: 500;
        font-size: 10px;
        text-transform: uppercase;
        border-radius: 10px;
        display: inline-block;
        &:hover

    {
        color: #fff;
    }

    }

    .ob-workforce--green {
        background: #3CB55B;
    }

    .ob-workforce--red {
        background-color: #FA6767;
    }

    .remove-emptycount {
        margin-top: -25px;
        &:hover

    {
        margin-top: -25px;
    }

    }

    .p-25 {
        padding-left: 22px
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/UpdateEmpDetails.vue